import React from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';

import LoadingState from './components/LoadingState/LoadingState';
import SportsEventTypeInfo from './components/SportsEventTypeInfo/SportsEventTypeInfo';
import { sportsEventTypeInfoWidgetModel, useSportsEventTypeInfoWidget } from './model';

const SportsEventTypeInfoWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsEventTypeInfoWidget();
  const eventTypeInfo = useSelector(widgetSelect.eventTypeInfo);
  const isLoading = useSelector(widgetSelect.isLoading);

  if (isLoading) {
    return <LoadingState />;
  }
  if (!eventTypeInfo) {
    return null;
  }

  return <SportsEventTypeInfo eventTypeInfo={eventTypeInfo} />;
};

SportsEventTypeInfoWidget.model = sportsEventTypeInfoWidgetModel;

export default withWidgetTestId(SportsEventTypeInfoWidget, 'sports-event-type-info');
